import { useMemo, type ReactNode } from 'react';

const isValidReactNode = (value: unknown): value is ReactNode => {
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    value === null ||
    value === undefined
  ) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.every(isValidReactNode);
  }

  return !!value && typeof value === 'object' && 'type' in value;
};

const useSanitizedValues = (input: Record<string, unknown>): Record<string, ReactNode> => {
  return useMemo(() => {
    const result: Record<string, ReactNode> = {};

    for (const [key, value] of Object.entries(input)) {
      if (isValidReactNode(value)) {
        result[key] = value as ReactNode;
      }
    }
    return result;
  }, [input]);
};

export default useSanitizedValues;
